import React, {useState} from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as snackbarActions from "../../actions/snackbarActions";
import PageTitle from "../Utils/smsTitle";
import {SubHeader} from "../../Containers/SubHeader";
import ReusableTabs, {TabPanel} from "../Utils/Dialogs/ReusableTabs";
import TheatreList from "./TheatreList";
import ExternalSurgeonList from "./ExternalSurgeonList";

const tabHeading = ['Operating Theatres', 'External Surgeons'];

const SurgerySettings = ({actions, snackbars}) => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="journals">
            <PageTitle title="Surgery Settings"/>
            <SubHeader title="Surgery" subTitle="Settings"/>
            <div style={{marginLeft: '1rem', marginRight: '1rem'}}>
            <ReusableTabs value={value} handleChange={handleChange} tabHeading={tabHeading}>
                <TabPanel value={value} index={0}>
                    <TheatreList actions={actions} snackbars={snackbars}/>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <ExternalSurgeonList actions={actions} snackbars={snackbars}/>
                </TabPanel>
            </ReusableTabs>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    const {snackbar} = state;
    return {snackbars: snackbar};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)},
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SurgerySettings);
